import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import photo from "../assets/img/foto-tutu.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { useTranslation, Trans } from 'react-i18next';

export const Banner = () => {
  const { t } = useTranslation();

  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(100 - Math.random() * 100);
  const toRotate = [ t('lawyer'), t('developer') ];
  const period = 1000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(50);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline"><Trans i18nKey="tagline"></Trans></span>
                <h1>{`Arthur A. de Menezes\t`} <span className="txt-rotate" data-rotate=''><span className="wrap">{text}</span></span></h1>
                <p>
                  <Trans i18nKey="subtitle">
                  </Trans>
                </p>
                {/* The CV link follows the displayed language (see cv_url in i18n.js) */}
                <a href={t('cv_url')} target="_blank" rel="noopener noreferrer">
                  <button type="button"><Trans i18nKey="cv"></Trans><ArrowRightCircle size={25} /></button>
                </a>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={photo} alt="Arthur Araujo de Menezes"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
        <section id="scrollDown" className="scrollingDown">
              <a href="#skills" aria-label={t('skills')}><span></span></a>
      </section>
      </Container>
    </section>
  )
}